let DCRouteMapper = {
    'vcenter' : 'vc',
    'resourcePool': 'resourcepool',
    'vm': 'vm',
    'datacenter': 'datacenter',
    'cluster': 'cluster',
    'computeResource': 'computeresource'
};
export default DCRouteMapper;



// WEBPACK FOOTER //
// ./src/app/components/administration-main/deployment-container/dc-tree/dc-route-mapper.ts